/**
 * Everclear analytics event bus.
 * Loaded globally in theme.liquid — single source of truth for all tracking.
 *
 * Events (all publish as everclear:<name> to Shopify Web Pixels):
 *
 *   Scanner flow:
 *     scanner_opened        {}
 *     scan_started          { mode, eye }
 *     scan_completed        { mode, eye }
 *     product_found         { productTitle, eye }
 *     no_match              {}
 *     no_replacement        { scannedProduct }
 *
 *   Search flow:
 *     search_started        {}
 *     search_query          { query }
 *     search_product_selected  { productTitle }
 *     prescription_entered  { productTitle }
 *     prescription_continued { productTitle }
 *
 *   Product / order:
 *     product_page_viewed   { productTitle }
 *     interval_changed      { interval }
 *     order_started         { productTitle, interval }
 *     upsell_shown          { productTitle }
 *     upsell_accepted       {}
 *     upsell_declined       {}
 *     checkout_redirect     { productTitle, itemCount }
 *
 *   Signup:
 *     signup_started        { source, tag }
 *     signup_submitted      { source, tag }
 *
 *   QR modal (desktop):
 *     qr_modal_shown        {}
 *     qr_modal_continue_here {}
 *
 * Usage:
 *   window.everclearAnalytics.emit('scanner_opened');
 *   window.everclearAnalytics.emit('signup_started', { source: 'theme', tag: 'startpage-signup' });
 *   window.everclearAnalytics.on('scanner_opened', function(data) { ... });
 */
(function () {
  var bus = new EventTarget();

  function emit(name, data) {
    var payload = data || {};
    try {
      if (window.Shopify && window.Shopify.analytics) {
        window.Shopify.analytics.publish('everclear:' + name, payload);
      }
    } catch (e) {
      // Silent fail
    }
    bus.dispatchEvent(new CustomEvent(name, { detail: payload }));
  }

  function on(name, fn) {
    var handler = function (e) { fn(e.detail); };
    bus.addEventListener(name, handler);
    return function () { bus.removeEventListener(name, handler); };
  }

  window.everclearAnalytics = { emit: emit, on: on };
})();
